import type { UserProfile } from '../contexts/AuthContext';

export interface SangatiGroup {
  id: string;
  ownerUid: string;
  name: string;
  memberUids: string[];
  createdAt: string;
  updatedAt: string;
}

const groupKey = (uid: string) => `garuda_sangati_group_${uid}`;

export function loadSangatiGroup(uid: string): SangatiGroup | null {
  try {
    const raw = localStorage.getItem(groupKey(uid));
    return raw ? (JSON.parse(raw) as SangatiGroup) : null;
  } catch {
    return null;
  }
}

export function saveSangatiGroup(group: SangatiGroup): void {
  localStorage.setItem(groupKey(group.ownerUid), JSON.stringify(group));
}

export function createSangatiGroup(profile: UserProfile): SangatiGroup {
  const now = new Date().toISOString();
  const name = `${profile.alias || 'मेरा'} संगति समूह`;
  return {
    id: `${profile.uid}-${Date.now()}`,
    ownerUid: profile.uid,
    name,
    memberUids: [profile.uid],
    createdAt: now,
    updatedAt: now,
  };
}

export function upsertGroupMember(group: SangatiGroup, memberUid: string): SangatiGroup {
  if (group.memberUids.includes(memberUid)) return group;
  return {
    ...group,
    memberUids: [group.ownerUid, ...group.memberUids, memberUid].filter((uid, idx, all) => all.indexOf(uid) === idx),
    updatedAt: new Date().toISOString(),
  };
}

export function removeGroupMember(group: SangatiGroup, memberUid: string): SangatiGroup {
  if (memberUid === group.ownerUid) return group;
  return {
    ...group,
    memberUids: group.memberUids.filter(uid => uid !== memberUid),
    updatedAt: new Date().toISOString(),
  };
}
